<div class="admin-portal-scope font-portal text-foreground bg-background min-h-full">
  <div class="mx-auto flex max-w-(--largura-lista-max) gap-5 px-4 py-5">

    <div class="hidden md:block">
      <app-evento-sidebar
        [idEvento]="idEvento"
        [nome]="$any(evento())?.nome"
        [fotoUrl]="$any(evento())?.fotoEventoUrl"
        [ability]="ability()"
        paginaAtiva="checkins"
      />
    </div>

    <main class="flex min-w-0 flex-1 flex-col gap-4">

      <!-- No mobile a sidebar não é renderizada (`hidden md:block`), então este
           é o único caminho de volta para o evento. -->
      <a
        class="md:hidden -mb-1 inline-flex w-fit items-center gap-1 text-sm font-semibold text-muted-foreground no-underline hover:text-foreground"
        [routerLink]="['/private/meus-eventos', idEvento]"
      >
        <ng-icon name="lucideChevronLeft" size="16px" />
        <span class="truncate">{{ $any(evento())?.nome || 'Voltar ao evento' }}</span>
      </a>

      <div class="flex flex-wrap items-center justify-between gap-4">
        <div class="flex items-baseline gap-3">
          <h1 class="m-0 text-[22px] font-bold tracking-[-0.01em]">Check-ins</h1>
          <span class="text-sm text-muted-foreground">
            {{ presentes() | number: '1.0-0' }} de {{ totalEvento() | number: '1.0-0' }} presentes
          </span>
        </div>

        <div class="flex items-center gap-2.5">
          <button
            type="button"
            hlmBtn
            variant="outline"
            size="icon-sm"
            [class]="impressora()?.conectada() ? 'size-[2rem] border-[#00E35E] text-[#0A7A35]' : 'size-[2rem]'"
            (click)="impressora()?.abrir()"
            [title]="impressora()?.conectada() ? 'Impressora conectada' : 'Conectar impressora'"
            [attr.aria-label]="impressora()?.conectada() ? 'Impressora conectada' : 'Conectar impressora'"
          >
            <ng-icon name="lucidePrinter" size="15px" />
          </button>

          <button
            type="button"
            hlmBtn
            variant="outline"
            size="sm"
            class="h-[2rem] px-[16px] text-[11pt]"
            (click)="convites().open()"
          >
            Convidar
          </button>

          <button
            type="button"
            hlmBtn
            variant="solid"
            size="sm"
            class="h-[2rem] gap-1.5 px-[16px] text-[11pt]"
            (click)="abrirScanner()"
          >
            <ng-icon name="lucideCamera" size="15px" />
            Abrir câmera
          </button>
        </div>
      </div>

      <!--
        Dois cards com conteúdo, no lugar de três com um número cada. O
        progresso responde "quanto falta"; o último check-in responde "o que eu
        acabei de fazer", que é o que o operador confere depois de bipar.

        ponytail: os números não são filtros. O endpoint só aceita filtro,
        sessaoId e sort — segmento clicável aqui precisaria de faceta no backend.
      -->
      <div class="grid gap-3 md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]">
        <div class="rounded-card border border-border bg-card px-4 py-3">
          <div class="flex items-baseline justify-between gap-3">
            <span class="text-[12px] text-muted-foreground">Progresso do check-in</span>
            <span class="text-[12px] text-muted-foreground">{{ progressoPct() }}%</span>
          </div>
          <div class="mt-1 flex items-baseline gap-1.5">
            <span class="text-[22px] font-bold tracking-[-0.01em]">{{ presentes() | number: '1.0-0' }}</span>
            <span class="text-[13px] text-muted-foreground">de {{ totalEvento() | number: '1.0-0' }} ingressos</span>
          </div>
          <div
            class="mt-[0.5rem] h-[6px] w-full overflow-hidden rounded-full bg-muted"
            role="progressbar"
            [attr.aria-valuenow]="presentes()"
            [attr.aria-valuemin]="0"
            [attr.aria-valuemax]="totalEvento()"
            [attr.aria-label]="'Check-ins realizados: ' + presentes() + ' de ' + totalEvento()"
          >
            <div class="h-full rounded-full bg-[#0A7A35] transition-all" [style.width.%]="progressoPct()"></div>
          </div>
          <div class="mt-1.5 text-[12px] text-muted-foreground">
            {{ pendentes() | number: '1.0-0' }} pendente(s)
          </div>
        </div>

        @if (ultimoCheckin(); as ultimo) {
          <button
            type="button"
            class="rounded-card border border-border bg-card px-4 py-3 text-left hover:border-primary"
            [hlmDropdownMenuTrigger]="menuHistorico"
            align="end"
            [title]="'Ver os últimos ' + historico().length + ' check-ins que você registrou'"
          >
            <div class="flex items-baseline justify-between gap-3">
              <span class="text-[12px] text-muted-foreground">Último check-in</span>
              <span class="text-[12px] text-muted-foreground">{{ ultimo.horario }}</span>
            </div>
            <div class="mt-1 truncate text-[15px] font-bold">{{ ultimo.nome }}</div>
            <div class="mt-0.5 truncate text-[12px] text-muted-foreground">
              {{ ultimo.lote }} &middot; {{ ultimo.operador }}
            </div>
            <div class="mt-1.5 text-[12px] font-semibold text-primary">
              Ver os últimos {{ historico().length }}
            </div>
          </button>
          <ng-template #menuHistorico>
            <hlm-dropdown-menu class="admin-portal-scope w-[22rem]">
              <hlm-dropdown-menu-label>Check-ins que você registrou nesta sessão</hlm-dropdown-menu-label>
              <hlm-dropdown-menu-separator />
              <div class="p-1">
                @for (c of historico(); track $index) {
                  <div class="flex items-baseline justify-between gap-3 px-2 py-1.5">
                    <div class="min-w-0">
                      <div class="truncate text-sm font-semibold">{{ c.nome }}</div>
                      <div class="truncate text-[12px] text-muted-foreground">
                        {{ c.lote }} &middot; {{ c.operador }}
                      </div>
                    </div>
                    <span class="shrink-0 text-[12px] text-muted-foreground">{{ c.horario }}</span>
                  </div>
                }
              </div>
            </hlm-dropdown-menu>
          </ng-template>
        } @else {
          <!-- Vazio que ensina o próximo passo, em vez de só constatar. -->
          <div class="rounded-card border border-dashed border-border px-4 py-3">
            <div class="text-[12px] text-muted-foreground">Último check-in</div>
            <div class="mt-1 text-[13px] text-muted-foreground">
              Nenhum registrado por você nesta sessão. Abra a câmera ou use o botão Check-in de uma
              linha — os últimos aparecem aqui.
            </div>
          </div>
        }
      </div>

      <!-- ── Desktop: tabela ─────────────────────────────────────────── -->
      <div class="hidden md:block">
        <app-admin-table
          storageKey="checkins"
          [columns]="colunas"
          [badgeColumns]="colunasBadge"
          [truncateColumns]="colunasTruncadas"
          primaryColumn="participante"
          [cellTemplates]="{ status: celulaStatus, janela: celulaCheckins }"
          [initialDensity]="'compact'"
          [initialHidden]="colunasOcultas"
          [selectable]="true"
          (selectionChange)="selecionados.set($event)"
          [rows]="linhas()"
          [loading]="list.loading()"
          [error]="list.error()"
          [totalRows]="list.totalRows()"
          [actions]="acoes"
          [rowId]="rowId"
          (rowDblClick)="checkinPorDuploClique($event)"
          [rowLabel]="rowLabel"
          [showRowCount]="false"
        >
          <div bulk-actions class="flex flex-wrap gap-2">
            <button
              type="button"
              hlmBtn
              variant="outline"
              size="sm"
              class="h-[1.75rem] px-2.5 text-[10pt] normal-case"
              [disabled]="emLote()"
              (click)="checkinEmLote()"
            >
              {{ emLote() ? 'Registrando…' : 'Registrar check-in dos selecionados' }}
            </button>
            <!-- Mesmo flag da ação de linha: o lote não pode ser atalho para o
                 que a linha não deixa fazer, nem sumir onde ela aparece. -->
            @if (vmContext().podeImprimirEtiqueta) {
              <button
                type="button"
                hlmBtn
                variant="outline"
                size="sm"
                class="h-[1.75rem] px-2.5 text-[10pt] normal-case"
                (click)="imprimirEtiquetasEmLote()"
              >
                Imprimir etiquetas dos selecionados
              </button>
            }
          </div>

          <app-checkin-toolbar
            toolbar
            [busca]="buscaLocal()"
            [sessoes]="sessoes()"
            [sessaoSelecionada]="sessaoId()"
            [ordem]="ordem()"
            [ordenacoes]="ordenacoes()"
            [exportando]="exportando()"
            [podeExportar]="podeExportar()"
            [filtroPeriodo]="chipsFiltro().periodo"
            [filtrosLista]="chipsFiltro().listas"
            [campos]="camposBusca()"
            [filtros]="filtros()"
            (buscaChange)="buscar($event)"
            (sessaoChange)="filtrarSessao($event)"
            (ordemChange)="ordenar($event)"
            (listaChange)="filtrarLista($event)"
            (textoChange)="filtrarTexto($event)"
            (periodoChange)="filtrarPeriodo($event)"
            (limpar)="limparFiltros()"
            (exportar)="confirmarExportacao()"
          />
        </app-admin-table>

        <app-admin-paginator
          [pageIndex]="list.pageIndex()"
          [pageSize]="list.pageSize()"
          [totalPages]="list.totalPages()"
          [disabled]="list.loading()"
          (pageChange)="onPageChange($event)"
        />
      </div>

      <!-- ── Mobile: cards + scroll infinito ─────────────────────────── -->
      <div class="md:hidden">
        <!-- Mesmos inputs e saídas do desktop: um filtro que existe numa
             largura e some na outra é divergência de lógica, não de layout.
             flex-wrap (e não block) porque o host já e flex com gap: em block
             os chips perdem o gap e colam uns nos outros. -->
        <app-checkin-toolbar
          class="mb-3 flex-wrap"
          [busca]="buscaLocal()"
          [sessoes]="sessoes()"
          [sessaoSelecionada]="sessaoId()"
          [ordem]="ordem()"
            [ordenacoes]="ordenacoes()"
          [exportando]="exportando()"
          [podeExportar]="podeExportar()"
          [filtroPeriodo]="chipsFiltro().periodo"
          [filtrosLista]="chipsFiltro().listas"
          [campos]="camposBusca()"
          [filtros]="filtros()"
          (buscaChange)="buscar($event)"
          (sessaoChange)="filtrarSessao($event)"
          (ordemChange)="ordenar($event)"
          (listaChange)="filtrarLista($event)"
          (textoChange)="filtrarTexto($event)"
          (periodoChange)="filtrarPeriodo($event)"
          (limpar)="limparFiltros()"
          (exportar)="confirmarExportacao()"
        />

        @if (list.error()) {
          <div class="rounded-card border border-border bg-card px-4 py-10 text-center" aria-live="polite">
            <p class="m-0 mb-3 text-sm text-destructive">Não foi possível carregar os check-ins.</p>
            <button type="button" hlmBtn variant="outline" size="sm" (click)="list.refresh()">
              Tentar de novo
            </button>
          </div>
        } @else if (linhas().length === 0 && !list.loading()) {
          <div class="rounded-card border border-border bg-card px-4 py-10 text-center" aria-live="polite">
            <p class="m-0 text-sm text-muted-foreground">
              @if (list.search()) {
                Ninguém encontrado para «{{ list.search() }}». Confira a grafia, ou busque pelo código do ingresso.
              } @else {
                Nenhum ingresso vendido ainda. Quando as vendas começarem, os participantes aparecem aqui.
              }
            </p>
          </div>
        } @else {
          <div class="flex flex-col gap-4">
            @for (row of linhas(); track row.id) {
              <article class="rounded-card border border-border bg-card p-4 shadow-card">
                <header class="mb-3 flex items-start justify-between gap-3">
                  <h2 class="m-0 min-w-0 flex-1 text-[0.95rem]/[1.2] font-bold break-words">{{ row.nome }}</h2>
                  <span hlmBadge [status]="row.badgeStatus" class="shrink-0">{{ row.statusLabel }}</span>
                </header>

                <dl class="m-0 flex flex-col gap-1">
                  @for (campo of row.detalhes; track campo.label) {
                    <div class="flex items-baseline justify-between gap-4">
                      <dt class="shrink-0 text-[0.8rem] text-muted-foreground">{{ campo.label }}</dt>
                      <dd class="m-0 truncate text-right text-[0.8rem]">{{ campo.value }}</dd>
                    </div>
                  }
                </dl>

                @if (row.janelaDestaque; as janela) {
                  <div class="mt-3 flex items-center justify-between gap-3 rounded-[10px] bg-muted px-3 py-2">
                    <div class="flex min-w-0 flex-col">
                      <span class="text-[0.8rem] text-muted-foreground">{{ janela.periodo }}</span>
                      @if (row.janelasRestantes > 0) {
                        <span class="text-[0.7rem] text-muted-foreground">
                          + {{ row.janelasRestantes }} outra(s) janela(s)
                        </span>
                      }
                    </div>
                    <span hlmBadge [status]="janela.badgeStatus" class="shrink-0">{{ janela.statusLabel }}</span>
                  </div>
                }

                <hr class="my-4 border-0 border-t border-border" />
                <div class="flex items-center gap-2">
                  @if (row.acoes.includes('checkin')) {
                    <button
                      type="button"
                      hlmBtn
                      variant="outline"
                      class="h-12 flex-1"
                      [disabled]="emCheckin().has(row.id)"
                      (click)="confirmarCheckin(row)"
                    >
                      {{ row.forcaraCheckin ? 'Forçar check-in' : 'Check-in' }}
                    </button>
                  }
                  <button
                    type="button"
                    hlmBtn
                    variant="ghost"
                    [class]="row.acoes.includes('checkin') ? 'h-12 w-12 shrink-0' : 'h-12 flex-1'"
                    (click)="detalhes().abrir(row)"
                    title="Detalhes e mais ações"
                    aria-label="Detalhes e mais ações"
                  >
                    {{ row.acoes.includes('checkin') ? '⋯' : 'Detalhes' }}
                  </button>
                </div>
              </article>
            }

            @if (list.hasMore()) {
              <div #sentinela class="rounded-card border border-border bg-card p-4 opacity-75" aria-hidden="true">
                <span class="block h-3.5 w-1/2 animate-pulse rounded bg-muted"></span>
                <span class="mt-2.5 block h-3 animate-pulse rounded bg-muted"></span>
                <span class="mt-2.5 block h-3 w-4/5 animate-pulse rounded bg-muted"></span>
              </div>
              <p class="m-0 text-center text-[13px] text-muted-foreground" aria-live="polite">Carregando mais…</p>
            }
          </div>
        }
      </div>
    </main>
  </div>

  <!-- ── Células que não são texto ─────────────────────────────────────── -->
  <ng-template #celulaStatus let-r>
    <!-- Ícone no lugar do rótulo: numa lista longa, "presente ou não" se lê de
         relance.

         Pendente e realizado são o MESMO check, mudando só a cor — decisão de
         produto. O pendente é #C9C9C9, bem mais claro que o texto: com um
         cinza médio o check "cheio" lia como já realizado, que é o oposto do
         que ele diz. Claro assim ele lê como slot vazio, esperando.

         E clarear resolveu de quebra o problema de "informação só na cor":
         contra o verde #0A7A35, o pendente saiu de 1,05:1 (com #666, mesma
         luminância — invisível para quem não separa verde de cinza) para
         3,3:1. Agora os dois estados diferem em claro/escuro, não só em matiz.

         O preço assumido é o outro lado: #C9C9C9 dá 1,66:1 contra o card
         branco, abaixo do mínimo de 3:1 de contraste de ícone. Vale porque
         pendente é a AUSÊNCIA de um evento — quem precisa saltar é o realizado
         e o expirado. O texto de cada estado continua no title e no
         aria-label, então leitor de tela não depende de nada disso.

         Expirado é RELÓGIO, não alerta: o ingresso não está errado, o prazo é
         que acabou. -->
    <span
      class="inline-flex"
      [class]="r.presente ? 'text-[#0A7A35]' : r.status === 'expirado' ? 'text-[#946A00]' : 'text-[#C9C9C9]'"
      [title]="r.presente ? 'Check-in realizado' : r.status === 'expirado' ? 'Expirado' : 'Check-in pendente'"
      role="img"
      [attr.aria-label]="r.presente ? 'Check-in realizado' : r.status === 'expirado' ? 'Expirado' : 'Check-in pendente'"
    >
      <ng-icon
        [name]="r.status === 'expirado' ? 'lucideClock' : 'lucideCircleCheckBig'"
        size="18px"
      />
    </span>
  </ng-template>

  <ng-template #celulaCheckins let-r>
    <!--
      A célula mostra o HORÁRIO do check-in, não o status da janela: quem olha a
      coluna quer saber se entrou e quando. O estado das janelas continua a um
      clique, na mini-tabela.
    -->
    @if (r.janelas.length === 0 && !r.presente) {
      <span class="text-muted-foreground">--</span>
    } @else {
      <button
        type="button"
        class="inline-flex items-center gap-1.5 rounded-full border border-border bg-card px-2.5 py-0.5 text-[10pt] font-semibold hover:border-primary hover:text-primary"
        [class.text-muted-foreground]="!r.presente"
        [hlmDropdownMenuTrigger]="menuJanelas"
        align="start"
        [title]="
          r.janelas.length
            ? 'Ver as ' + r.janelas.length + ' janela(s) de entrada'
            : 'Sem janela configurada'
        "
      >
        {{ r.presente ? r.dataCheckinLabel : 'Sem check-in' }}
        <span class="text-[8pt]">▾</span>
      </button>
      <ng-template #menuJanelas>
        <hlm-dropdown-menu class="admin-portal-scope w-[30rem]">
          <hlm-dropdown-menu-label>
            @if (r.presente) {
              Check-in em {{ r.dataCheckinLabel }}@if (r.operador !== '--') {
                <span> &middot; por {{ r.operador }}</span>
              }
            } @else {
              Check-in não realizado
            }
          </hlm-dropdown-menu-label>
          <hlm-dropdown-menu-separator />

          @if (r.janelas.length === 0) {
            <div class="px-3 py-2 text-sm text-muted-foreground">
              Este lote não tem janela de entrada configurada.
            </div>
          } @else {
            <!-- Mini-tabela: uma linha por janela. A janela ABERTA agora vem
                 destacada — é a única sobre a qual o operador ainda pode agir.
                 Janela encerrada sem check-in mostra `--`; janela futura fica em
                 branco, porque ainda não há o que dizer sobre ela. -->
            <div class="max-h-[15rem] overflow-y-auto overscroll-contain px-1 py-1">
              <table class="w-full text-sm">
                <thead>
                  <tr class="text-[11px] uppercase tracking-wide text-muted-foreground">
                    <th class="px-2 py-1 text-left font-semibold">Período</th>
                    <th class="px-2 py-1 text-left font-semibold">Check-in</th>
                    <th class="px-2 py-1 text-left font-semibold">Operador</th>
                    <th class="w-[1.5rem] px-2 py-1"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (j of r.janelas; track $index) {
                    <tr
                      [class]="
                        j.status === 'ativa'
                          ? 'border-t border-border bg-primary/10 font-semibold text-foreground'
                          : 'border-t border-border'
                      "
                    >
                      <td class="whitespace-nowrap px-2 py-1.5">
                        {{ j.periodoCurto }}
                        @if (j.status === 'ativa') {
                          <span class="ml-1 text-[10px] font-bold tracking-wide text-primary uppercase">agora</span>
                        }
                      </td>
                      <td class="whitespace-nowrap px-2 py-1.5">{{ j.celulaCheckin }}</td>
                      <td class="truncate px-2 py-1.5">{{ j.celulaOperador }}</td>
                      <td class="px-2 py-1.5">
                        @if (j.checkin) {
                          <span class="inline-flex text-[#0A7A35]" title="Check-in realizado nesta janela">
                            <ng-icon name="lucideCircleCheckBig" size="15px" />
                          </span>
                        } @else if (j.status === 'encerrada') {
                          <span class="inline-flex text-[#946A00]" title="Janela encerrada">
                            <ng-icon name="lucideClock" size="15px" />
                          </span>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </hlm-dropdown-menu>
      </ng-template>
    }
  </ng-template>

  <!-- Filhos sempre no template: `abrir()` não pode depender de um ciclo de CD
       criar o host. -->
  <app-checkin-detalhes [acoes]="acoes" (retroativoSolicitado)="abrirRetroativo($event)" />
  <app-checkin-retroativo (concluido)="aoRegistrarRetroativo()" />
  <app-checkin-impressora />
  <modal-convites-eventos-dados
    [id]="idEvento"
    [showRandomEmailgenerator]="true"
    (afterSave)="onConviteSalvo()"
  />
  <app-checkin-etiqueta (conectar)="impressora()?.abrir()" (impresso)="list.refresh()" />

  @if (scannerAberto()) {
    <!-- Estados sequenciais (lendo → processando → resultado), como no app.
         Uma leitura = uma requisição; a lista e o balanço só recarregam quando
         o scanner fecha. Ver `checkin-scanner.component.ts`. -->
    <app-checkin-scanner
      [idEvento]="idEvento"
      [operador]="operador()"
      [mobile]="mobile()"
      (registrado)="onCheckinDoScanner($event)"
      (fechar)="fecharScanner()"
    />
  }

  @if (toast(); as t) {
    <div
      class="fixed bottom-5 right-5 z-50 flex max-w-[440px] items-center gap-3.5 rounded-card border border-border bg-card p-3.5 shadow-card"
      role="status"
      aria-live="polite"
    >
      <span hlmBadge status="success" look="solid" class="shrink-0">✓</span>
      <div class="flex min-w-0 flex-col">
        <span class="text-sm font-semibold">{{ t.titulo }}</span>
        <span class="text-[12.5px] text-muted-foreground">{{ t.detalhe }}</span>
      </div>
      <button type="button" hlmBtn variant="ghost" size="sm" class="ml-auto shrink-0" (click)="fecharToast()">
        Fechar
      </button>
    </div>
  }
</div>
